<template>
  <div id="app">
    <v-header v-if="$route.meta.hasHeader"></v-header>
    <!--页面返回不刷新-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" style="margin-bottom:30px;"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" style="margin-bottom:30px;"></router-view>
    <v-footer v-if="$route.meta.hasHeader"></v-footer>
  </div>
</template>

<script>
import vHeader from 'common/header'
import vFooter from 'common/footer'
import { ShopAPI } from 'api/shop'
let shopAPI=new ShopAPI()
export default {
  name: 'App',
  watch: {
    $route (to, from) {
      if (to.path !== '/login' && to.path !== '/forgetPass' && to.path !== '/modifyPass' && !from.name) { // 跳转登录页不需要检查，登录完成再做检查，（解决请求接口没有token报错的bug）
        // 查询客户是否有临时单，有则跳转临时单详情
        // 检查临时单在三个页面做：1 app.vue  2 login.vue 3 orderConfirm.vue
        shopAPI.getTemporaryOrder().then(res => {
          if (res.extra && res.extra.orderNo) {
            this.$message.error('您有一个订单未确认，请进行处理~')
            this.$router.push({
              path: '/temporaryOrder',
              query: {
                orderNo: res.extra.orderNo
              }
            })
          }
        })
      }
    }
  },
  components: {
    vHeader,
    vFooter
  }
}
</script>


<style lang="scss">
@import "~assets/style/variable";

#app {
  height: 100%;
  position: relative;
  --themeMain: #195982;
  --themeSub: #eb6869;
  --textMain: #17242a;
  --textSub: #9aa8ad;
  --sizeX: 1.12em; //大一号
  --sizeS: 0.9em; //小一号
  --sizeSS: 0.8em; //小二号

  --gray: #a4adb3;
  --border: #e0eaee;
  --white: #fff;
  --block: #000;
  --contentWidth: 1260px;


  // 分页栏自定义样式
  .el-pagination {
    margin: 20px 0;
    text-align: center;
    display: block;

    .active {
      color: black !important;
      font-weight: 700 !important;
      font-size: 15px !important;
    }

    .number {
      color: #999;
      font-weight: normal;
      font-size: 14px;
    }
  }



  .app-p-item {
    float: left;
    margin-left: 6px;
    margin-right: 6px;
    margin-top: 15px;
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;

    &:nth-child(5n) {
      margin-right: 0px;
    }

    .product-wrap {
      border: 1px solid #fff;
      transition: border-color .1s ease;
      padding: 8px 8px 12px 8px;
      position: relative;
      width: 200px;
      box-sizing: border-box;

      .p-price {
        font-size: 18px;
        color: $color-sub-theme;
        font-weight: bold;
        margin-top: 5px;

        span {
          font-size: 14px;
          font-weight: normal;
        }
      }

      .p-title {
        width: 100%;
        height: 18px;
        line-height: 18px;
        color: var(--textMain);
        margin: 6px 0px;
        overflow: hidden;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      .p-desc {
        width: 100%;
        height: 15px;
        line-height: 15px;
        color: var(--themeMain);
        font-size: 0.85em;
        overflow: hidden;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      .number-div {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 110px;
        height: 30px;
      }

      .p-btn-sku {
        height: 32px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 6px;

        .btn {
          width: 90px;
          height: 32px;
          line-height: 32px;
          border-radius: 4px;
          text-align: center;
          color: white;
          font-size: 14px;
          cursor: pointer;
          user-select: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }

        .red-btn {
          background-color: var(--themeSub);
          //width: 80px;
          height: 30px;
        }

        .gray-btn {
          background-color: var(--gray);
        }

        .limit {
          flex: 1;
          text-align: center;

          span {
            color: red;
            font-weight: bold;
            margin: 0px 2px;
            font-size: 1.1em;
          }
        }
      }
    }

    .product-wrap:hover {
      border-color: #e9e9e9;
      box-shadow: 0 0 3px 3px #f8f8f8;
      border-radius: 5px;
    }
  }

  .app-p-img {
    width: 100%;
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }

  .app-p-mark {
    left: 0;
    top: 10px;
    background-color: $color-sub-theme;
    color: $color-white;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 15px;
    position: absolute;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .app-tag {
    background-color: $color-sub-theme;
    color: $color-white;
    padding: 2px 10px;
    font-size: 13px;
    line-height: 16px;
    border-radius: 4px;
    margin-right: 12px;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .app-zhe {
    background-color: $color-sub-theme;
    color: $color-white;
    padding: 1px 4px;
    font-size: 11px;
    line-height: 14px;
    margin-right: 2px;
    border-radius: 2px;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .app-p-btn {
    width: 100px;
    height: 32px;
    line-height: 32px;
    border: 1px solid var(--textSub);
    border-radius: 4px;
    text-align: center;
    color: var(--textSub);
    font-size: 12px;
    cursor: pointer;
    // 不可选中
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .app-p-btn:hover {
    color: var(--themeMain);
    border-color: var(--themeMain);
  }

  .app-left-menu {
    float: left;
    color: #545e62;
    width: 180px;
    line-height: 38px;
    margin-top: -10px;
    border-right: 1px solid $border;

    &>li {
      font-weight: bold;
      letter-spacing: 3px;
      text-align: center;
      cursor: pointer;

      &.active {
        color: $color-theme;
        font-weight: 800;
        font-size: 1.1em;
      }

      .sub-menu {
        display: none;

        &.show {
          display: block;
        }

        &>li {
          color: $color-sub-text;
          font-weight: normal;

          &.active {
            color: $color-theme;
            font-weight: 600;
          }
        }
      }
    }
  }

  .app-search-box {
    height: 30px;
    line-height: 30px;
    display: flex;
    margin-bottom: 10px;
    position: relative;

    input {
      width: 250px;
      text-indent: 10px;
      border: 1px solid $border;
    }

    .icon-close {
      position: absolute;
      top: 10px;
      left: 230px;
      font-size: 12px;
      color: #9aa8ad;
      cursor: pointer;
    }

    .button {
      min-width: 80px;
      letter-spacing: 3px;
      background-color: $color-theme;
      color: $color-white;
      text-align: center;
      cursor: pointer;
    }
  }

  .app-empty {
    width: inherit;
    text-align: center;
    margin-top: 200px;
    font-size: 20px;
    color: $color-sub-text;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;

    span {
      width: fit-content;
    }

    .back-main {
      color: $color-theme;
      text-decoration: underline;
      font-size: 14px;
      line-height: 40px;
      cursor: pointer;
    }
  }

  .app-pagination {
    width: fit-content;
    height: fit-content;
    font-size: 20px;
    color: $color-sub-text;
    display: flex;
    flex-direction: row;
    margin: 20px 30px 80px auto;
    padding: 0px;
  }

  .app-pop {
    .el-dialog {
      min-width: 680px;
    }

    .el-dialog__body {
      padding: 5px 20px 10px;
    }

    .popup-desc {
      margin-bottom: 20px;
      color: $color-sub-text;
    }

    .popup-content {
      border-top: 1px solid #e0eaee;
      border-bottom: 1px solid #e0eaee;
      max-height: 440px;
      overflow-x: hidden;
      overflow-y: scroll;

      &>p {
        color: $color-text-1;
        font-size: 16px;
        font-weight: bold;
        margin-top: 18px;
      }

      ul {
        display: flex;
        flex-direction: column;
        //overflow-y: scroll;

        li {
          display: flex;
          flex-direction: column;
          line-height: 50px;
          position: relative;

          .item-name {
            padding-left: 0px;

            i {
              border-radius: 5px;
              margin-top: 1px;
            }
          }

          .item-ration {
            color: $color-sub-text;
            font-size: 12px;
            position: absolute;
            right: 230px;
          }

          .item-price {
            color: $color-sub-theme;
            font-weight: bold;
            position: absolute;
            right: 130px;
            width: 85px;
          }

          .goods-num {
            position: absolute;
            right: 10px;
            top: 12px;
          }

          .goods-ku {
            position: absolute;
            right: 10px;
          }
        }
      }
    }
  }



}
</style>



// WEBPACK FOOTER //
// src/App.vue